import React, { useMemo, useState, useEffect } from 'react';
import { Modal, Button, Typography, Space } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { downloadFileFromURL } from 'helpers';
import { SERVER_IP } from 'assets/Config';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './pdf-viewer-modal.scss';

const { Title } = Typography;

const PdfViewerModal = ({ selectedFile, visible, onClose }) => {
	const globalRedux = useSelector((state) => state?.globalRedux);
	const orgId = globalRedux?.selectedOrganization?._id;

	const [loading, setLoading] = useState(true);

	useEffect(() => {
		if (visible && selectedFile?._id) {
			setLoading(true);
		}
	}, [visible, selectedFile?._id]);

	const previewUrl = useMemo(() => {
		return `${SERVER_IP}/booking/preview/${selectedFile?._id}?orgId=${orgId}`;
	}, [selectedFile?._id, orgId]);

	const downloadUrl = useMemo(() => {
		return `${SERVER_IP}/booking/download/${selectedFile?._id}?orgId=${orgId}`;
	}, [selectedFile?._id, orgId]);

	const handleDownload = () => {
		downloadFileFromURL(downloadUrl);
	};

	return (
		<Modal
			open={visible}
			onCancel={onClose}
			footer={null}
			width="60%"
			className="pdf-viewer-modal"
			centered={false} // 👈 remove vertical centering
			style={{ top: 0 }} // 👈 align near top
			destroyOnClose>
			<div className="pdf-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, marginRight: 40 }}>
				<Title level={4} style={{ margin: 0 }}>
					{loading ? <Skeleton width={120} height={24} /> : `INVOICE`}
					{/* {loading ? <Skeleton width={120} height={24} /> : `INV-${selectedFile?.invoiceNumber}`} */}
				</Title>
				{/* <Space>
					{loading ? (
						<Skeleton width={100} height={32} borderRadius={8} />
					) : (
						<Button type="primary" icon={<DownloadOutlined />} onClick={handleDownload}>
							Download
						</Button>
					)}
				</Space> */}
			</div>

			{/* Skeleton loader */}
			{loading && <Skeleton height={600} borderRadius={0} style={{ marginBottom: 12 }} containerClassName="pdf-skeleton-loader" />}

			{/* Iframe PDF viewer */}
			<iframe
				className="pdf-viewer-modal-iframe"
				title="PDF Viewer"
				src={previewUrl}
				width="100%"
				height="600px"
				style={{
					border: '1px solid #ccc',
					borderRadius: 0,
					display: loading ? 'none' : 'block',
				}}
				onLoad={() => setLoading(false)}
			/>
		</Modal>
	);
};

export default PdfViewerModal;
